import { createStore } from 'vuex'

import Global from './global'
import User from './user'
import Album from './album'
import BicycleExemption from './bicycle-exemption'
import AlbumItem from './album-item'
import HikingTrails from './hiking-trails'
import Profile from './profile'
import Map from './map'
import Notifications from './notifications'
import Shop from './shop'

export default createStore({
  ...Global,
  modules: {
    user: User,
    album: Album,
    'bicycle-exemption': BicycleExemption,
    'album-item': AlbumItem,
    'hiking-trails': HikingTrails,
    profile: Profile,
    map: Map,
    notifications: Notifications,
    shop: Shop
  }
})
